export enum CheckboxSize {
  XS = 'checkbox-xs',
  SM = 'checkbox-sm',
  MD = 'checkbox-md',
  LG = 'checkbox-lg',
}
